import axios from 'axios';

const api = '/api/agent-types';

export const getAllAgentTypes = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};
